import { Menu, MenuItem, Typography } from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import StyledButtonV2 from "../../../../components/app/StyledButtonV2";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { ReportExportType } from "../../../../queries/use-report-export";

const EXPORT_OPTIONS: { label: string; value: ReportExportType }[] = [
  { label: "CSV File", value: "CSV" },
  // { label: "PDF File", value: "PDF" },
];

interface ReportExportProps {
  onClick: (v: ReportExportType) => void;
  disabled?: boolean;
}

const ReportExport = ({ onClick, disabled }: ReportExportProps) => {
  return (
    <PopupState variant="popover" popupId="report-export-menu">
      {(menuList) => (
        <>
          <StyledButtonV2
            variant="contained"
            sIcon={<FileDownloadOutlinedIcon fontSize="small" />}
            label="Export to File"
            size="medium"
            {...bindTrigger(menuList)}
            disabled={disabled}
          />

          <Menu
            {...bindMenu(menuList)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            slotProps={{
              paper: {
                sx: {
                  mt: 0.5,
                  borderRadius: "8px",
                  boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                  minWidth: 140,
                },
              },
            }}
          >
            {EXPORT_OPTIONS.map((opt) => (
              <MenuItem
                key={opt.value}
                onClick={() => {
                  menuList.close();
                  onClick(opt.value);
                }}
                sx={{
                  py: 1,
                  px: 2,
                  fontSize: 14,
                  color: "#373D41",
                  "&:hover": { backgroundColor: "#F5F7FA" },
                }}
              >
                <Typography fontSize={14} fontWeight={400}>
                  {opt.label}
                </Typography>
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </PopupState>
  );
};

export default ReportExport;
